@if (icon) {
<span
  class="badge badge-icon d-flex align-items-center justify-content-center p-0"
  [title]="title"
>
  <fa-icon
    class="icon"
    [size]="size"
    [icon]="icon"
    [animation]="iconAnimation"
  ></fa-icon
></span>
}
<span
  data-e2e="added-badge"
  class="badge badge-text p-0"
  [class.pl-1]="!!icon"
  [title]="title"
>
  @if (label) {
  {{ label }}
  } @else {
  <ng-content></ng-content>
  }
</span>
